// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2RUNV","dragIcon":"Choice_dragIcon__MDz2z","left":"Choice_left__3M8Q7","input":"Choice_input__33hNL"};